import type { FC, ReactElement, ReactNode } from 'react';

import classNames from 'classnames';

import { ArrowLeftTinyIcon } from '../../SVGIcons/ArrowLeftTinyIcon';
import { CrossIcon } from '../../SVGIcons/CrossIcon';
import { TooltipInfoIcon } from '../../SVGIcons/TooltipInfoIcon';
import Tooltip from '../../Tooltip';

import classes from './DialogHeader.module.scss';

export type DialogHeaderProps = {
  title: ReactNode;
  onGoBack?: VoidFunction | (() => Promise<void>);
  onClose?: VoidFunction | (() => Promise<void>);
  className?: string;
  decorationsWrapperClassName?: string;
  titleClassName?: string;
  titleDataTestId?: string;
  goBackBtnDataTestId?: string;
  closeBtnDataTestId?: string;
  tooltipBtnDataTestId?: string;
  tooltipContent?: string | ReactElement;
  headerLeftElement?: ReactNode;
};

export const DialogHeader: FC<DialogHeaderProps> = ({
  title,
  onGoBack,
  onClose,
  className,
  decorationsWrapperClassName,
  titleClassName,
  titleDataTestId,
  goBackBtnDataTestId,
  closeBtnDataTestId,
  tooltipBtnDataTestId,
  tooltipContent,
  headerLeftElement,
}) => {
  return (
    <div
      className={classNames(
        classes.dialogHeader,
        {
          [classes.dialogHeaderWithTitle]: !!title,
        },
        className,
      )}
    >
      <div className={classNames(classes.dialogHeaderDecorationsWrapper, decorationsWrapperClassName)}>
        <div className={classes.headerHalfGradient} />
        <div className={classes.headerLeftGradient} />
        {headerLeftElement && <div className={classes.dialogHeaderLeftElement}>{headerLeftElement}</div>}
        <div className={classes.bottomHeaderGradientLine} />
      </div>
      <div
        className={classNames('animation-slide-up', classes.dialogHeaderTitle, titleClassName)}
        data-testid={titleDataTestId}
      >
        {title}
      </div>
      {onGoBack && (
        <button className={classes.dialogHeaderBtnArrow} data-testid={goBackBtnDataTestId} onClick={onGoBack}>
          <ArrowLeftTinyIcon />
        </button>
      )}
      {onClose && (
        <button
          className={classes.dialogHeaderBtnClose}
          data-testid={closeBtnDataTestId || 'closeButton'}
          onClick={onClose}
        >
          <CrossIcon />
        </button>
      )}
      {tooltipContent && (
        <Tooltip
          isBig
          content={tooltipContent}
          dataTestId={tooltipBtnDataTestId}
          wrapperClassName={classes.dialogHeaderBtnTooltip}
        >
          <TooltipInfoIcon />
        </Tooltip>
      )}
    </div>
  );
};
